import React from 'react';
import styled from '@emotion/styled';
import { Flex, Hide, Icon } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import { themeGet } from 'styled-system';

import Heading from '@/components/Heading';
import Text from '@/components/Text';

const StyledFlex = styled(Flex)`
  border-radius: ${themeGet('radii.md')};
  border: 1px solid #dedede;
  background: white;
`;

/**
 * @typedef {Object} BannerProps
 * @property {string} title
 * @property {string} message
 * @property {import('react').ReactNode} [cta]
 * @property {import('react').ReactNode} [iconComponent]
 * @property {string} [iconName]
 */

/**
 * @param {BannerProps} props
 */
const Banner = ({ title, message, iconName = 'info', cta, iconComponent }) => {
  const icon = iconComponent || (
    <Icon name={iconName} color="primary" size={40} mr={4} />
  );

  return (
    <StyledFlex
      py={4}
      px={6}
      flexDirection={['column', null, 'row']}
      alignItems="start"
    >
      <Hide xs sm>
        {icon}
      </Hide>
      <Flex flexDirection="column">
        <Flex>
          <Hide md lg>
            {icon}
          </Hide>
          <Heading.h5>{title}</Heading.h5>
        </Flex>
        {message && (
          <Flex flex={1} mt={[2, null, 1]}>
            <Text color="text.heading" medium>
              {message}
            </Text>
          </Flex>
        )}
      </Flex>
      {cta && (
        <Flex
          alignSelf={['stretch', null, 'center']}
          ml={[0, null, 8]}
          mt={[4, null, 0]}
        >
          {cta}
        </Flex>
      )}
    </StyledFlex>
  );
};

Banner.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  cta: PropTypes.node,
  iconComponent: PropTypes.node,
  iconName: PropTypes.string,
};

export default Banner;
